/**
 * Order box shared functions
 */

export const orderboxmixins = {
    methods  : {
        /**
         * Re-stracture data
         * check ordermixins.js newboxproperty function for properties we need 
         * (type) this property will be remove in future so avoid using it
         * (price) this property will be remove in future so avoid using it
         * (flavors) this property will be the  flavors
         */
        restractureboxproperty (data, subid, groupid) {
            return {
                id         : data.box_id,
                box_name   : data.box_name,
                type       : data.box_id,
                flavors    : data.flavors,
                price      : 0,
                sub_id     : subid,
                group_id   : groupid
            }
        },
        /**
         * Subscription order grouping
         * Group all order by box type and flavors
         */
         groupboxorder(orderboxes) {
            let order = [];

            console.log('orderboxes', orderboxes)

            orderboxes.forEach((box) => {
               const flavors    = [...new Set(box.flavors.slice())];
               const exist      = order.find(o => o.id == box.id && o.flavors.sort((a, b) => a.id - b.id).every((f, i) => f.id === flavors.sort((a, b) => a.id - b.id)[i].id));

               console.log('exist', exist, box)

               if(exist) {
                   exist.count++
               } else {
                   order = [...order, {
                       count      : 1,
                       id         : box.id,
                       box_name   : box.box_name,
                       flavors    : flavors,
                       flavorsname: box.flavors ? box.flavors.filter((value, index, self) => index === self.findIndex((t) => t.id === value.id)): []
                   }]
               }
           });


           return order;
   
         }
    }
}